<template>
    <div class="rs-index-container">
        <img class="banner" src="../../../../public/static/images/activity/red-story/banner2025.png" alt="" />
        <router-view v-slot="{ Component }">
            <keep-alive>
                <component :is="Component" v-if="$route.meta.keepAlive" :key="$route.path"></component>
            </keep-alive>
            <component :is="Component" v-if="!$route.meta.keepAlive"></component>
        </router-view>
        <van-tabbar active-color="white" inactive-color="#e41926" route :border="false">
            <van-tabbar-item replace to="/activity/read-story-2025/display">作品展示</van-tabbar-item>
            <van-tabbar-item replace to="/activity/read-story-2025/enroll">报名通道</van-tabbar-item>
            <van-tabbar-item replace to="/activity/read-story-2025/introduce">活动介绍</van-tabbar-item>
            <van-tabbar-item replace to="/activity/read-story-2025/trends">活动动态</van-tabbar-item>
        </van-tabbar>
    </div>
</template>

<script>
export default {
    // "最美红色故事发声人"
    name: "RS2025Index"
}
</script>

<style lang="less" scoped>
.rs-index-container {
    box-sizing: border-box;
    padding-bottom: var(--van-tabbar-height);
}
</style>

<style>
.van-tabbar {
    background-color: #fbe29b;
}

.van-tabbar-item--active {
    background-color: #e41926;
}
</style>
